









import { BaseSelect, selectName } from '#components/baseSelect';

import { apiProvider } from '../api';
import { NAME } from '../constants';

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		nr: String,
		text: String,
		value: Number,
		isViewable: { type: Boolean, default: false },
		isClearable: { type: Boolean, default: true },
	},
	data() {
		return {
			storeObject: NAME,
			apiProvider,
			emptyObject: {
				value: null,
				text: null,
				nr: null,
			},
		};
	},
	methods: {
		dbToBaseMapper(data: any) {
			return {
				value: data.OSTATNIPA_ID,
				text: data.TEXT,
				nr: data.OSTATNI_NR,
			};
		},
	},
});
